import { baseApi } from "common/redux/core/api.base";
import { MocService } from "../../services/moc.service";
import {
  MocDetail,
  MocListView,
  EngineeringAnalysisView,
  ImpactAssessmentView,
  RiskAssessmentView,
  ActionRegisterView,
  SafeguardView,
  MocDocumentAccessDetails,
  DecisionPackageView,
  MocHistoryView
} from "../../models/moc.model";

const mocApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMocs: build.query<MocListView, void>({
      queryFn: () => MocService.getMocs()
    }),
    getMocById: build.query<MocDetail, string>({
      queryFn: (mocId) => MocService.getMocById(mocId)
    }),
    getMocEngineeringAnalysis: build.query<EngineeringAnalysisView, string>({
      queryFn: (mocId) => MocService.getMocEngineeringAnalysis(mocId)
    }),
    getMocImpactAssessment: build.query<ImpactAssessmentView, string>({
      queryFn: (mocId) => MocService.getMocImpactAssessment(mocId)
    }),
    getMocRiskAssessment: build.query<RiskAssessmentView, string>({
      queryFn: (mocId) => MocService.getMocRiskAssessment(mocId)
    }),
    getMocActionRegister: build.query<ActionRegisterView, string>({
      queryFn: (mocId) => MocService.getMocActionRegister(mocId)
    }),
    getMocSafeguards: build.query<SafeguardView, string>({
      queryFn: (mocId) => MocService.getMocSafeguards(mocId)
    }),
    getMocDocumentAccessDetails: build.query<MocDocumentAccessDetails, string>({
      queryFn: (mocId) => MocService.getMocDocumentAccessDetails(mocId)
    }),
    getMocDecisionPackage: build.query<DecisionPackageView, string>({
      queryFn: (mocId) => MocService.getMocDecisionPackage(mocId)
    }),
    getMocHistory: build.query<MocHistoryView, string>({
      queryFn: (mocId) => MocService.getMocHistory(mocId)
    })
  })
});

export const {
  useGetMocsQuery,
  useLazyGetMocByIdQuery,
  useLazyGetMocEngineeringAnalysisQuery,
  useLazyGetMocImpactAssessmentQuery,
  useLazyGetMocRiskAssessmentQuery,
  useLazyGetMocActionRegisterQuery,
  useLazyGetMocSafeguardsQuery,
  useLazyGetMocDocumentAccessDetailsQuery,
  useLazyGetMocDecisionPackageQuery,
  useGetMocHistoryQuery,
  useLazyGetMocHistoryQuery
} = mocApi;
